<div class="procedures-list">
  @if ((null == selectedProcedure || '' == selectedProcedure) && inProgressProceduresList.length > 0) {
    <h2>Actions en cours</h2>
  }
  @if ((null == selectedProcedure || '' == selectedProcedure) && inProgressProceduresList.length > 0) {
    <div class="procedure-grid w-100 mb-4">
      @for (procedure of inProgressProceduresList; track procedure) {
        <div class="col-12" (click)="getInProgressProcedure(procedure)">
          <app-procedure-card
            [icon]="'icons/procedures/landline/'+procedure.code+'.png'"
            [cursor]="true"
            [text]="procedure.label"
            [status]="procedure.status"
          ></app-procedure-card>
        </div>
      }
    </div>
  }

  @if ((null == selectedProcedure || '' == selectedProcedure) && proceduresList.length > 0) {
    <h2>Actions disponibles</h2>
  }
  @if ((null == selectedProcedure || '' == selectedProcedure) && proceduresList.length > 0) {
    <div class="procedure-grid w-100 mb-4">
      @for (procedure of proceduresList; track procedure) {
        <div class="col-12" (click)="getProcedure(procedure)">
          <app-procedure-card
            [icon]="'icons/procedures/landline/'+procedure.code+'.png'"
            [cursor]="true"
            [text]="procedure.label"
            [status]="procedure.status"
          ></app-procedure-card>
        </div>
      }
    </div>
  }
</div>

@if (constHelper.PROCEDURE_IDENTIFY_LANDLINE == selectedProcedure) {
  <app-identify-line [procedureCode]="selectedProcedure" [landLine]="selectedLine" [name]="selectedLine.comment" [line]="null"></app-identify-line>
}
@if (constHelper.PROCEDURE_TERMINATE_LANDLINE == selectedProcedure) {
  <app-terminate-line [procedureCode]="selectedProcedure" [landLine]="selectedLine" [line]="null"></app-terminate-line>
}
@if (constHelper.PROCEDURE_TECHNICAL_ASSISTANCE_LANDLINE == selectedProcedure) {
  <app-technical-assistance [procedureCode]="selectedProcedure" [landLine]="selectedLine" [line]="null"></app-technical-assistance>
}
@if (constHelper.PROCEDURE_MODIFY_APPOINTMENT == selectedProcedure) {
  <app-modify-appointment [procedureCode]="selectedProcedure" [landLine]="selectedLine" [lastMessage]="lastMessage"></app-modify-appointment>
}
